import React, { useState, useImperativeHandle, forwardRef } from 'react'

import { ModalBase, Botao, ModalBaseProps } from 'src/componentes'

import { Corpo, Texto, Titulo } from './styles'
import { ModalReingressoInadimplenteRef } from './tipos'

const ModalInadimplente: React.ForwardRefRenderFunction<
  ModalReingressoInadimplenteRef,
  ModalBaseProps
> = ({ backdrop, acaoPrimaria }, ref) => {
  const [aberta, definirAberta] = useState(false)

  const [protocolo, definirProtocolo] = useState('')

  const fechar = () => {
    definirProtocolo(null)
    definirAberta(false)
  }

  const abrir = (protocolo: string) => {
    definirProtocolo(protocolo)
    definirAberta(true)
  }

  useImperativeHandle<
    ModalReingressoInadimplenteRef,
    ModalReingressoInadimplenteRef
  >(ref, () => ({
    fechar,
    abrir
  }))

  const acaoSucesso = () => {
    fechar()
    acaoPrimaria(null)
  }

  return (
    <ModalBase aberta={aberta} backdrop={backdrop}>
      <Corpo>
        <Titulo>Aviso de inadimplência!</Titulo>
        <>
          <Texto>
            Você possui pendências financeiras com nossa instuição e é
            necessário a regularização para novas contratações.
          </Texto>
          <Texto>
            Entre em contato com nosso suporte no telefone (51) 3062-9322 (Whats
            e/ou ligação) ou aguarde o contato de um de nossos especialistas.
          </Texto>
          <Texto>
            O número do seu protocolo de atendimento é {protocolo ?? ''}
          </Texto>
          <Texto>Bons estudos e conte conosco.</Texto>
        </>

        <Botao texto="OK" type="button" onClick={() => acaoSucesso()} />
      </Corpo>
    </ModalBase>
  )
}

export const ModalReingressoInadimplente = forwardRef(ModalInadimplente)
